import {
  MediaLibCategoryEnum,
  useMediaLibPanelStoreShallow,
  useMediaLibUploadFiles,
} from "@editor/modules/media-lib";

interface IProps {
  accept: string;
  multiple?: boolean;

  moveToCategory?: MediaLibCategoryEnum;

  onUploadStart?: () => void;
}

export const useMediaLibPanelUploadFiles = ({
  accept,
  multiple,
  moveToCategory = MediaLibCategoryEnum.AllFiles,
  onUploadStart,
}: IProps) => {
  const { setCategory, setSelectedFolderId, setFiles, selectedFolderId } =
    useMediaLibPanelStoreShallow((s) => ({
      setFiles: s.setFiles,
      setCategory: s.setCategory,
      setSelectedFolderId: s.setSelectedFolderId,
      selectedFolderId: s.selectedFolderId,
    }));

  return useMediaLibUploadFiles({
    accept,
    multiple,
    moveToCategory,
    onUploadStart,
    setCategory,
    setSelectedFolderId,
    selectedFolderId,
    onAddFiles: (files) => setFiles({ files, extend: true }),
  });
};
